import icons from '../../../../icons';
import widgets from '../../../widgets';
import { selectOption, selectComponent } from '../../../config_ui/config_components/base_components';
import { targetStateEventEditor } from './targetStateEventEditor';
import { simpleClone } from '../../../../helpers';
import { TooltipKey } from '../../../machinelogic_tooltips';


/**
 * @typedef {Object} LocalModalTargetState
 * @property {string} eventDefinition the event definition uuid|value or mqtt topic
 * @property {(mqtt|digital_input)} eventType the event type. Either mqtt or digital_input
 * @property {string} guardExpression the guard expression
 * @property {string} stateName the state name
 */


/**
 * opens a modal to edit the target state transition parameters.
 * @param {Object} params
 * @param {Object} params.targetState the target state
 * @param {Array} params.states an array of states in the state machine
 * @param {Object} params.library the library object
 * @param {(LocalModalTargetState) => void} params.onEditTargetStateDone callback to save the fields in the form
 * @return {void} appends an html element to the body element
 */
export const targetStateEditModal = ({targetState, states, library, onEditTargetStateDone}) => {
  const modalContainer = $('<div>').addClass('ml_fsm_modal_background');
  const localModalTargetState = simpleClone(targetState);

  modalContainer.empty();
  modalContainer.css('display', 'flex');

  const lEditStateModal = $('<div>').addClass('ml_fsm_target_state_expanded');
  const lExpandedContainerHeader = $('<div>').addClass('ml_fsm_target_state_expanded_header')
    .html(`
          <p>Define Transition of<br>
            <b>Next State</b>
          </p>
    `);
  const lExpandedContainerContent = $('<div>').addClass('ml_fsm_target_state_expanded_container');
  const lEditOkContainer = $('<div>').addClass('ml_fsm_target_state_ok_container');
  const lEditChevron = $('<div>').addClass('ml_fsm_target_state_chevron');
  const lEditDoneButton = $('<button>')
    .addClass('ml_fsm_target_state_expanded_ok')
    .text('done')
    .on('click', () => {
      onEditTargetStateDone(localModalTargetState);
      modalContainer.remove();
    }); // we only save the changes once the user presses "Done"

  const lEditCancelButton = $('<button>')
    .addClass(icons.close + ' ml_fsm_target_state_expanded_cancel')
    .on('click', () => modalContainer.remove()); // if the user presses the cancel button, the changes will be ignored.


  const lStateOptions = states.map(pState => selectOption(pState.stateName, pState.stateName, false, localModalTargetState.stateName));

  const lMissingTargetState = !states.find(pState => pState.stateName === localModalTargetState.stateName);
  if(lMissingTargetState) {
    lStateOptions.push(selectOption(localModalTargetState.stateName, '(Missing State)', true, true));
  }

  const lNextStateNameStringComponent = selectComponent(
    "State Name",
    lStateOptions,
    localModalTargetState.stateName,
    "Target state's name",
    pValue => {
      localModalTargetState.stateName = pValue;
      lNextStateNameStringComponent.getSelectContainer().removeClass('ml_validator_red');
    },
    {selectDivClass: lMissingTargetState ? 'ml_select_widget ml_validator_red' : 'ml_select_widget'}
  );

  const lGuardWidget = widgets.stringWidget(
    "Condition <span style='font-weight: normal'>( Optional )</span>",
    "Additional condition to enter target state",
    localModalTargetState.guardExpression,
    pValue => localModalTargetState.guardExpression = pValue,
    null,
    { tooltipKey: TooltipKey.FSM_CONDITION }
  ).addClass('v_layout spaced');

  lEditStateModal.append(
    lExpandedContainerHeader,
    lExpandedContainerContent.append(
      lNextStateNameStringComponent.widget,
      targetStateEventEditor({localModalTargetState, library}),
      lGuardWidget
    ),
    lEditOkContainer.append(
      lEditChevron,
      lEditDoneButton,
    ),
    lEditCancelButton
  );

  $('body').append(
    modalContainer.append(
      lEditStateModal
    )
  );
};
